import React from 'react';
import T from 'prop-types';

const SharingSocials = ({
  shareOptions: {
    post_url,
    post_title,
    post_description,
  },
}) => (
  <div className="col-xxs-12 col-md-3 d-flex justify-content-md-end justify-content-center filters-social-box">
    <div className="d-flex flex-column filter">
      <div id="fb-root" className=" fb_reset">
        <div
          style={{
            position: 'absolute',
            top: '-10000px',
            width: 0,
            height: 0,
            }}
        >
          <div />
        </div>
      </div>
      <div className="filter-label">Share</div>
      <div className="d-flex">
        <div
          className="fb-share-button m-r-sm"
          data-href={post_url}
          data-mobile-iframe="true"
          data-size="small"
        >
          <a
            className="fb-xfbml-parse-ignore text-md text-white text-bold b-rds social-btn social-btn-fb"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(post_url)}src=sdkpreparse`}
            target="_blank"
            rel="noopener noreferrer"
            title="Share on Facebook"
          >
            <span className="hidden">facebook</span>
          </a>
        </div>
        <a
          className="twitter-share-button text-md text-white text-bold b-rds m-r-sm social-btn social-btn-tw"
          href={`https://x.com/share?ref_src=twsrc%5Etfw&amp;url=${encodeURI(post_url)}&amp;text=${encodeURI(post_title)}via=Apptopia&amp;hashtags=AppData`}
          title="Share on X"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="hidden">X</span>
        </a>
        <a
          className="text-md text-white text-bold b-rds social-btn social-btn-li"
          href={`http://www.linkedin.com/shareArticle?mini=true&amp;url=${encodeURI(post_url)}&amp;summary=${encodeURI(post_description)}&amp;title=${encodeURI(post_title)}`}
          target="_blank"
          rel="noopener noreferrer"
          title="Share on Linkedin"
        >
          <span className="hidden">linkedin</span>
        </a>
      </div>
    </div>
</div>
);

SharingSocials.propTypes = {
  shareOptions: T.object.isRequired,
};
export default SharingSocials;
